module.exports = __webpack_public_path__ + "img/articles_p.936ebab7.svg";